import { FC } from "react";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  makeStyles,
} from "@material-ui/core";
import { CheckboxProps } from "@material-ui/core/Checkbox";

import theme from "theme";
interface CustomCheckboxProps {
  checkboxColor?: string;
  dense?: boolean;
}

const useCheckboxStyles = makeStyles({
  root: {
    color: (props: CustomCheckboxProps) =>
      props.checkboxColor || theme.custom.palette.green.main,
    padding: (props: CustomCheckboxProps) =>
      props.dense ? theme.spacing(0.5) : theme.spacing(1),
    marginLeft: (props: CustomCheckboxProps) =>
      props.dense ? theme.spacing(0.5) : 0,
  },
  checked: {
    "&&": {
      color: (props: CustomCheckboxProps) =>
        props.checkboxColor || theme.custom.palette.green.main,
    },
  },
  icon: {
    borderRadius: 0,
  },
});

interface CustomFormControlLabelProps {
  labelTextColor?: string;
}

const useFormControlLabelStyles = makeStyles({
  root: {
    color: (props: CustomFormControlLabelProps) =>
      props.labelTextColor || theme.palette.text.primary,
    textAlign: "left",
  },
});

interface CheckboxFieldProps {
  label: string;
}

const CheckboxField: FC<
  CheckboxFieldProps &
    CheckboxProps &
    CustomCheckboxProps &
    CustomFormControlLabelProps
> = ({ label, ...props }) => {
  const { checkboxColor, dense, labelTextColor, ...restProps } = props;
  const checkboxClasses = useCheckboxStyles({ checkboxColor, dense });
  const formControlLabelClasses = useFormControlLabelStyles({ labelTextColor });

  return (
    <FormControl>
      <FormControlLabel
        className={formControlLabelClasses.root}
        control={
          <Checkbox
            classes={{
              root: checkboxClasses.root,
              checked: checkboxClasses.checked,
            }}
            {...restProps}
          />
        }
        label={label}
      />
    </FormControl>
  );
};

export default CheckboxField;
